import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Gallery from '@adsk/bim360-matrix-react-gallery';

class IssueAttachmentGallery extends PureComponent {
  render() {
    const {attachments, closeGallery, container, selectedAttachmentIndex} = this.props;

    if (!attachments) {
      return null;
    }

    return (
      <Gallery container={container} selectedItem={selectedAttachmentIndex} items={attachments} onHide={closeGallery} />
    );
  }
}

IssueAttachmentGallery.displayName = 'IssueAttachmentGallery';

IssueAttachmentGallery.propTypes = {
  attachments: PropTypes.array,
  selectedAttachmentIndex: PropTypes.number,
  container: PropTypes.object,
  closeGallery: PropTypes.func.isRequired
};

export default IssueAttachmentGallery;
